export const initialState = [];

export const all = (state = initialState) => state;
